import React from 'react';
import './Footer.css';
import packageJson from '../../package.json';
import { useLocalization } from '../contexts/LocalizationContext';

const Footer = () => {
  const { t } = useLocalization();

  // t() returns the raw key while translations load - fall back to English
  const tf = (key, fallback) => {
    const translation = t(key);
    return translation === key ? fallback : translation;
  };

  return (
    <footer className="app-footer">
      <div className="container">
        <p className="footer-text">© 2025 Poligon. {tf('footer.rights', 'All rights reserved.')} {tf('footer.version', 'Version')} {packageJson.version}</p>
      </div>
    </footer>
  );
};

export default Footer;